module.exports = __webpack_public_path__ + "static/img/tu21.02f54bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu21.png
// module id = 1qhx
// module chunks = 128